import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Navbar from '../home/components/Navbar';
import Footer from '../home/components/Footer';
import SEOHead from '../../components/feature/SEOHead';

const ServiceAreaPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const serviceAreas = [
    {
      name: '前金區',
      description: '中心所在地，提供最完善的日照服務',
      locations: ['文武二街', '中華三路', '自強一路', '七賢二路'],
      time: '5-10分鐘',
      highlight: true,
    },
    {
      name: '新興區',
      description: '鄰近前金區，交通便利快速抵達',
      locations: ['中山一路', '民生一路', '復興一路', '六合路'],
      time: '10-15分鐘',
      highlight: false,
    },
    {
      name: '苓雅區',
      description: '涵蓋文化中心周邊，服務範圍廣泛',
      locations: ['四維三路', '中正一路', '三多路', '光華路'],
      time: '15-20分鐘',
      highlight: false,
    },
    {
      name: '鹽埕區',
      description: '歷史街區，提供貼心長者照護',
      locations: ['大勇路', '五福四路', '七賢三路', '建國四路'],
      time: '10-15分鐘',
      highlight: false,
    },
    {
      name: '三民區',
      description: '高雄市中心區域，服務人口眾多',
      locations: ['建工路', '九如二路', '民族一路', '十全路'],
      time: '20-25分鐘',
      highlight: false,
    },
    {
      name: '鼓山區',
      description: '西子灣周邊，風景優美的照護服務',
      locations: ['臨海二路', '鼓山一路', '美術東二路', '明誠四路'],
      time: '20-30分鐘',
      highlight: false,
    },
  ];

  const nearbyLandmarks = [
    { name: '高雄市立大同醫院', distance: '步行約8分鐘', icon: 'ri-hospital-line' },
    { name: '前金國小', distance: '步行約5分鐘', icon: 'ri-school-line' },
    { name: '中央公園捷運站', distance: '車程約5分鐘', icon: 'ri-subway-line' },
    { name: '高雄市文化中心', distance: '車程約10分鐘', icon: 'ri-building-line' },
    { name: '愛河', distance: '步行約10分鐘', icon: 'ri-water-flash-line' },
    { name: '六合夜市', distance: '車程約8分鐘', icon: 'ri-store-2-line' },
  ];

  const structuredData = {
    "@context": "https://schema.org",
    "@type": "LocalBusiness",
    "name": "前金日間照顧中心",
    "description": "高雄市前金區專業日間照顧中心，提供失智症照護、失能照護、認知訓練等長照服務，服務範圍涵蓋前金區、新興區、苓雅區、鹽埕區、三民區、鼓山區等高雄市區。",
    "image": "https://static.readdy.ai/image/e6fb9fe30ffa661384912f3cccf551e7/d5aea6c2e30695f7c421b6c6d03bc7cc.png",
    "telephone": "07-2416568",
    "address": {
      "@type": "PostalAddress",
      "streetAddress": "文武二街163號5樓",
      "addressLocality": "前金區",
      "addressRegion": "高雄市",
      "postalCode": "801",
      "addressCountry": "TW"
    },
    "geo": {
      "@type": "GeoCoordinates",
      "latitude": 22.6273,
      "longitude": 120.2861
    },
    "areaServed": [
      { "@type": "City", "name": "高雄市前金區" },
      { "@type": "City", "name": "高雄市新興區" },
      { "@type": "City", "name": "高雄市苓雅區" },
      { "@type": "City", "name": "高雄市鹽埕區" },
      { "@type": "City", "name": "高雄市三民區" },
      { "@type": "City", "name": "高雄市鼓山區" }
    ],
    "openingHoursSpecification": [
      {
        "@type": "OpeningHoursSpecification",
        "dayOfWeek": ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
        "opens": "08:00",
        "closes": "17:00"
      }
    ],
    "priceRange": "$$",
    "serviceArea": {
      "@type": "GeoCircle",
      "geoMidpoint": {
        "@type": "GeoCoordinates",
        "latitude": 22.6273,
        "longitude": 120.2861
      },
      "geoRadius": "10000"
    }
  };

  const breadcrumbData = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "itemListElement": [
      {
        "@type": "ListItem",
        "position": 1,
        "name": "首頁",
        "item": "https://qianjin-daycare.com/"
      },
      {
        "@type": "ListItem",
        "position": 2,
        "name": "服務區域",
        "item": "https://qianjin-daycare.com/service-area"
      }
    ]
  };

  return (
    <div className="min-h-screen bg-cream-50">
      <SEOHead
        title="高雄前金日照中心服務區域｜前金區、新興區、苓雅區、鹽埕區、三民區、鼓山區"
        description="前金日間照顧中心服務範圍涵蓋高雄市六大行政區：前金區、新興區、苓雅區、鹽埕區、三民區、鼓山區。提供失智照護、失能照護、長照3.0服務及交通接送，電話：07-2416568。"
        keywords="前金日照服務區域,高雄日照中心,前金區日照,新興區日照,苓雅區日照,鹽埕區日照,三民區日照,鼓山區日照,長照3.0"
        canonical="https://qianjin-daycare.com/service-area"
        lastModified="2025-07-15"
        jsonLd={[structuredData, breadcrumbData]}
      />
      
      <Navbar />

      {/* Hero Section */}
      <section className="relative pt-24 pb-16 bg-gradient-to-br from-baby-blue-100 via-cream-100 to-baby-blue-50">
        <div className="max-w-7xl mx-auto px-6">
          <nav className="text-sm mb-8" aria-label="麵包屑導航">
            <ol className="flex items-center gap-2">
              <li>
                <Link to="/" className="text-gray-500 hover:text-baby-blue-500 transition-colors">首頁</Link>
              </li>
              <li className="text-gray-400">/</li>
              <li className="text-baby-blue-600 font-medium">服務區域</li>
            </ol>
          </nav>

          <div className="grid lg:grid-cols-2 gap-12 items-center">
            <div>
              <span className="inline-block px-4 py-1.5 bg-baby-blue-200 text-baby-blue-600 rounded-full text-sm font-medium mb-4">
                高雄在地服務
              </span>
              <h1 className="text-4xl lg:text-5xl font-bold text-baby-blue-600 mb-6 leading-tight">
                <strong>前金日照中心</strong><br />
                <span className="text-cream-500">服務區域</span>涵蓋<br />
                高雄市六大行政區
              </h1>
              <p className="text-lg text-gray-600 mb-8 leading-relaxed">
                <strong>高雄市前金區日間照顧中心</strong>位於市中心精華地段，交通便利，提供專業<strong>失智症照護</strong>、<strong>失能照護</strong>及<strong>認知訓練</strong>服務。我們的服務範圍涵蓋<strong>前金區、新興區、苓雅區、鹽埕區、三民區、鼓山區</strong>，並提供貼心的交通接送服務。
              </p>
              <div className="flex flex-wrap gap-4">
                <a
                  href="tel:07-2416568"
                  className="inline-flex items-center gap-2 bg-baby-blue-500 hover:bg-baby-blue-600 text-white px-6 py-3 rounded-full font-medium transition-colors cursor-pointer whitespace-nowrap"
                >
                  <i className="ri-phone-line"></i>
                  立即諮詢 07-2416568
                </a>
                <Link
                  to="/#contact"
                  className="inline-flex items-center gap-2 border-2 border-baby-blue-400 text-baby-blue-600 hover:bg-baby-blue-50 px-6 py-3 rounded-full font-medium transition-colors cursor-pointer whitespace-nowrap"
                >
                  <i className="ri-map-pin-line"></i>
                  查看交通資訊
                </Link>
              </div>
            </div>

            <div className="relative">
              <div className="rounded-2xl overflow-hidden shadow-xl">
                <iframe
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d14713.847!2d120.2861!3d22.6273!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x346e04681b0b0b0b%3A0x0!2z6auY6ZuE5biC5YmN6YeR5Y2A!5e0!3m2!1szh-TW!2stw!4v1"
                  width="100%"
                  height="400"
                  style={{ border: 0 }}
                  allowFullScreen
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                  title="前金日間照顧中心服務區域地圖"
                  className="w-full"
                ></iframe>
              </div>
              <div className="absolute -bottom-4 -left-4 bg-white rounded-xl shadow-lg p-4">
                <div className="flex items-center gap-3">
                  <div className="w-12 h-12 bg-baby-blue-100 rounded-full flex items-center justify-center">
                    <i className="ri-car-line text-2xl text-baby-blue-500"></i>
                  </div>
                  <div>
                    <p className="text-sm text-gray-500">交通接送服務</p>
                    <p className="font-bold text-baby-blue-600">115元/趟</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Service Areas Grid */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-16">
            <span className="text-sm text-baby-blue-500 font-medium tracking-wider uppercase">Service Areas</span>
            <h2 className="text-3xl lg:text-4xl font-bold text-baby-blue-600 mt-2 mb-4">
              <strong>高雄日照中心</strong>服務範圍
            </h2>
            <p className="text-gray-600 max-w-2xl mx-auto">
              <strong>前金日間照顧中心</strong>服務範圍涵蓋高雄市六大行政區，提供專業<strong>長者日間照護</strong>及便利的交通接送服務
            </p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
            {serviceAreas.map((area, index) => (
              <article
                key={index}
                className={`relative bg-cream-50 rounded-2xl p-6 transition-all duration-300 hover:shadow-lg hover:-translate-y-1 cursor-pointer ${
                  area.highlight ? 'ring-2 ring-baby-blue-400' : ''
                }`}
              >
                {area.highlight && (
                  <span className="absolute -top-3 left-6 px-3 py-1 bg-baby-blue-500 text-white text-xs font-medium rounded-full">
                    中心所在地
                  </span>
                )}
                <div className="flex items-start justify-between mb-4">
                  <div>
                    <h3 className="text-xl font-bold text-baby-blue-600 mb-1">
                      <strong>高雄市{area.name}</strong>
                    </h3>
                    <p className="text-sm text-gray-500">{area.description}</p>
                  </div>
                  <div className="w-10 h-10 bg-baby-blue-100 rounded-full flex items-center justify-center flex-shrink-0">
                    <i className="ri-map-pin-2-line text-baby-blue-500"></i>
                  </div>
                </div>
                
                <div className="space-y-2 mb-4">
                  {area.locations.map((location, locIndex) => (
                    <div key={locIndex} className="flex items-center gap-2 text-sm text-gray-600">
                      <i className="ri-checkbox-circle-line text-baby-blue-400"></i>
                      <span>{location}</span>
                    </div>
                  ))}
                </div>

                <div className="pt-4 border-t border-cream-300">
                  <div className="flex items-center justify-between">
                    <span className="text-sm text-gray-500">預估車程</span>
                    <span className="font-bold text-baby-blue-500">{area.time}</span>
                  </div>
                </div>
              </article>
            ))}
          </div>
        </div>
      </section>

      {/* Location Details */}
      <section className="py-20 bg-gradient-to-b from-cream-100 to-white">
        <div className="max-w-7xl mx-auto px-6">
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            <div>
              <span className="text-sm text-baby-blue-500 font-medium tracking-wider uppercase">Location</span>
              <h2 className="text-3xl lg:text-4xl font-bold text-baby-blue-600 mt-2 mb-6">
                <strong>前金日照中心</strong>地理位置
              </h2>
              <p className="text-gray-600 mb-8 leading-relaxed">
                <strong>前金日間照顧中心</strong>位於<strong>高雄市前金區文武二街163號5樓</strong>，鄰近大同醫院、中央公園捷運站，交通便利，周邊生活機能完善，是<strong>高雄市日照中心</strong>的理想選擇。
              </p>

              <address className="not-italic bg-white rounded-2xl p-6 shadow-sm mb-8">
                <h3 className="font-bold text-baby-blue-600 mb-4 flex items-center gap-2">
                  <i className="ri-building-2-line"></i>
                  中心地址
                </h3>
                <p className="text-gray-700 mb-2">
                  <strong>高雄市前金區文武二街163號5樓</strong>
                </p>
                <p className="text-gray-600 text-sm mb-4">
                  郵遞區號：801
                </p>
                <div className="flex flex-wrap gap-3">
                  <a
                    href="https://maps.google.com/?q=高雄市前金區文武二街163號"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-flex items-center gap-2 text-sm text-baby-blue-500 hover:text-baby-blue-600 transition-colors cursor-pointer"
                  >
                    <i className="ri-map-2-line"></i>
                    在 Google 地圖中開啟
                  </a>
                </div>
              </address>

              <div className="grid grid-cols-2 gap-4">
                <div className="bg-white rounded-xl p-4 shadow-sm">
                  <div className="w-10 h-10 bg-baby-blue-100 rounded-full flex items-center justify-center mb-3">
                    <i className="ri-phone-line text-baby-blue-500"></i>
                  </div>
                  <p className="text-sm text-gray-500 mb-1">聯絡電話</p>
                  <a href="tel:07-2416568" className="font-bold text-baby-blue-600 hover:text-baby-blue-500 transition-colors cursor-pointer">
                    07-2416568
                  </a>
                </div>
                <div className="bg-white rounded-xl p-4 shadow-sm">
                  <div className="w-10 h-10 bg-baby-blue-100 rounded-full flex items-center justify-center mb-3">
                    <i className="ri-time-line text-baby-blue-500"></i>
                  </div>
                  <p className="text-sm text-gray-500 mb-1">服務時間</p>
                  <p className="font-bold text-baby-blue-600">週一至週五 08:00-17:00</p>
                </div>
              </div>
            </div>

            <div>
              <h3 className="font-bold text-baby-blue-600 mb-6 flex items-center gap-2">
                <i className="ri-compass-3-line"></i>
                周邊地標與設施
              </h3>
              <div className="grid grid-cols-2 gap-4">
                {nearbyLandmarks.map((landmark, index) => (
                  <div
                    key={index}
                    className="bg-white rounded-xl p-4 shadow-sm hover:shadow-md transition-shadow cursor-pointer"
                  >
                    <div className="w-10 h-10 bg-cream-200 rounded-full flex items-center justify-center mb-3">
                      <i className={`${landmark.icon} text-baby-blue-500`}></i>
                    </div>
                    <h4 className="font-medium text-gray-800 mb-1 text-sm">{landmark.name}</h4>
                    <p className="text-xs text-gray-500">{landmark.distance}</p>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Transport Service */}
      <section className="py-20 bg-baby-blue-600">
        <div className="max-w-7xl mx-auto px-6">
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            <div className="text-white">
              <span className="text-baby-blue-200 text-sm font-medium tracking-wider uppercase">Transport Service</span>
              <h2 className="text-3xl lg:text-4xl font-bold mt-2 mb-6">
                貼心交通接送服務
              </h2>
              <p className="text-baby-blue-100 mb-8 leading-relaxed">
                <strong>前金日間照顧中心</strong>提供專業的交通接送服務，讓長者安全舒適地往返中心。我們的接送車輛配備無障礙設施，由專業司機駕駛，確保每位長者的乘車安全。
              </p>
              
              <div className="space-y-4 mb-8">
                <div className="flex items-center gap-4">
                  <div className="w-12 h-12 bg-white/20 rounded-full flex items-center justify-center">
                    <i className="ri-wheelchair-line text-2xl"></i>
                  </div>
                  <div>
                    <h4 className="font-bold">無障礙接送車</h4>
                    <p className="text-baby-blue-200 text-sm">配備輪椅升降設備</p>
                  </div>
                </div>
                <div className="flex items-center gap-4">
                  <div className="w-12 h-12 bg-white/20 rounded-full flex items-center justify-center">
                    <i className="ri-shield-check-line text-2xl"></i>
                  </div>
                  <div>
                    <h4 className="font-bold">專業駕駛團隊</h4>
                    <p className="text-baby-blue-200 text-sm">受過專業照護訓練</p>
                  </div>
                </div>
                <div className="flex items-center gap-4">
                  <div className="w-12 h-12 bg-white/20 rounded-full flex items-center justify-center">
                    <i className="ri-route-line text-2xl"></i>
                  </div>
                  <div>
                    <h4 className="font-bold">彈性接送路線</h4>
                    <p className="text-baby-blue-200 text-sm">依據長者住所規劃最佳路線</p>
                  </div>
                </div>
              </div>

              <div className="bg-white/10 rounded-2xl p-6 backdrop-blur-sm">
                <div className="flex items-center justify-between mb-4">
                  <span className="text-baby-blue-200">交通接送費用</span>
                  <span className="text-2xl font-bold">115元/趟</span>
                </div>
                <p className="text-baby-blue-200 text-sm">
                  * 符合長照資格者可申請交通接送補助
                </p>
              </div>
            </div>

            <div className="relative">
              <img
                src="https://public.readdy.ai/ai/img_res/538c4c999b0b92f71f8424aec6509e40.jpg"
                alt="前金日照中心無障礙交通接送服務車輛，配備輪椅升降設備，專業司機協助高雄市長者安全上下車"
                title="高雄前金日間照顧中心交通接送服務"
                className="w-full h-[450px] object-cover object-top rounded-2xl shadow-2xl"
              />
              <div className="absolute -bottom-6 -right-6 bg-cream-300 rounded-xl p-4 shadow-lg">
                <div className="flex items-center gap-3">
                  <div className="w-12 h-12 bg-baby-blue-500 rounded-full flex items-center justify-center">
                    <i className="ri-car-line text-2xl text-white"></i>
                  </div>
                  <div>
                    <p className="text-sm text-gray-600">服務範圍</p>
                    <p className="font-bold text-baby-blue-600">高雄市六大區</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-gradient-to-br from-cream-100 via-white to-baby-blue-50">
        <div className="max-w-4xl mx-auto px-6 text-center">
          <h2 className="text-3xl lg:text-4xl font-bold text-baby-blue-600 mb-6">
            歡迎預約參觀<strong>前金日照中心</strong>
          </h2>
          <p className="text-gray-600 mb-8 max-w-2xl mx-auto">
            無論您住在<strong>前金區、新興區、苓雅區、鹽埕區、三民區或鼓山區</strong>，我們都能提供專業的<strong>日間照顧服務</strong>。歡迎來電預約參觀，讓我們為您的家人提供最好的照護。
          </p>
          
          <div className="flex flex-wrap justify-center gap-4 mb-12">
            <a
              href="tel:07-2416568"
              className="inline-flex items-center gap-2 bg-baby-blue-500 hover:bg-baby-blue-600 text-white px-8 py-4 rounded-full font-medium transition-colors cursor-pointer whitespace-nowrap shadow-lg"
            >
              <i className="ri-phone-line text-xl"></i>
              立即來電諮詢
            </a>
            <a
              href="https://www.facebook.com/p/前金社區日間照顧機構-100063908289224/"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 bg-white hover:bg-cream-100 text-baby-blue-600 px-8 py-4 rounded-full font-medium transition-colors cursor-pointer whitespace-nowrap shadow-lg border border-cream-300"
            >
              <i className="ri-facebook-circle-line text-xl"></i>
              Facebook 粉絲專頁
            </a>
          </div>

          <div className="grid md:grid-cols-3 gap-6">
            <div className="bg-white rounded-2xl p-6 shadow-sm">
              <div className="w-14 h-14 bg-baby-blue-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-map-pin-line text-2xl text-baby-blue-500"></i>
              </div>
              <h3 className="font-bold text-baby-blue-600 mb-2">中心地址</h3>
              <p className="text-gray-600 text-sm">高雄市前金區文武二街163號5樓</p>
            </div>
            <div className="bg-white rounded-2xl p-6 shadow-sm">
              <div className="w-14 h-14 bg-baby-blue-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-phone-line text-2xl text-baby-blue-500"></i>
              </div>
              <h3 className="font-bold text-baby-blue-600 mb-2">聯絡電話</h3>
              <p className="text-gray-600 text-sm">07-2416568</p>
            </div>
            <div className="bg-white rounded-2xl p-6 shadow-sm">
              <div className="w-14 h-14 bg-baby-blue-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-time-line text-2xl text-baby-blue-500"></i>
              </div>
              <h3 className="font-bold text-baby-blue-600 mb-2">服務時間</h3>
              <p className="text-gray-600 text-sm">週一至週五 08:00-17:00</p>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default ServiceAreaPage;
